/**
 * Owner: Masa Bayu
 * File: text-mark.ts
 * Date:Time: 2026-09-20 17:27
 * Description: Native QXW text mark model — CA-05 RC1 registry · { type } only.
 */
import { canonicalQXTextColorValue } from './text-formatting';
export const QX_TEXT_PLAIN_MARK_TYPES = [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'code-span',
    'subscript',
    'superscript',
];
export const QX_TEXT_FORMAT_MARK_TYPES = ['text-color', 'highlight'];
export const QX_TEXT_MARK_TYPES = [
    ...QX_TEXT_PLAIN_MARK_TYPES,
    ...QX_TEXT_FORMAT_MARK_TYPES,
];
export function isQXTextMarkType(value) {
    return QX_TEXT_MARK_TYPES.includes(value);
}
export function isQXTextPlainMarkType(value) {
    return QX_TEXT_PLAIN_MARK_TYPES.includes(value);
}
export function isQXTextFormatMarkType(value) {
    return QX_TEXT_FORMAT_MARK_TYPES.includes(value);
}
/**
 * Structural field-contract check for a mark object.
 * Does not validate QXW documents (15B.3 owns schema acceptance).
 */
export function isQXTextMark(value) {
    if (value === null || typeof value !== 'object' || Array.isArray(value)) {
        return false;
    }
    const record = value;
    if (typeof record.type !== 'string') {
        return false;
    }
    if (isQXTextPlainMarkType(record.type)) {
        return Object.keys(record).length === 1;
    }
    if (!isQXTextFormatMarkType(record.type)) {
        return false;
    }
    const keys = Object.keys(record);
    return (keys.length === 2 &&
        keys.includes('value') &&
        typeof record.value === 'string' &&
        canonicalQXTextColorValue(record.value) === record.value);
}
export function createQXTextMark(type) {
    if (isQXTextFormatMarkType(type)) {
        throw new Error('formatting mark requires a canonical color value');
    }
    if (!isQXTextPlainMarkType(type)) {
        throw new Error('unknown text mark type');
    }
    return Object.freeze({ type });
}
export function createQXTextFormatMark(type, value) {
    const canonical = canonicalQXTextColorValue(value);
    if (canonical === null) {
        throw new Error('color value must be canonical #RRGGBB');
    }
    return Object.freeze({ type, value: canonical });
}
//# sourceMappingURL=text-mark.js.map